import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import { Section, Container } from '@components/global';
import ExternalLink from '@common/ExternalLink';

import { ReactComponent as CnnLogo } from '@images/logos/cnn.svg';
import { ReactComponent as IqviaLogo } from '@images/logos/iqvia.svg';
import { ReactComponent as HelloAlfred } from '@images/logos/helloalfred.svg';
import { ReactComponent as AxialLogo } from '@images/logos/axial.svg';

const LOGOS = [
  {
    logo: CnnLogo,
    link: 'https://cnn.com',
  },
  {
    logo: IqviaLogo,
    link: 'https://www.iqvia.com',
  },
  {
    logo: HelloAlfred,
    link: 'https://helloalfred.com',
  },
  {
    logo: AxialLogo,
    link: 'https://axial.net',
  },
];

const UsedBy = () => (
  <StaticQuery
    query={graphql`
      query {
        art_story: file(
          sourceInstanceName: { eq: "art" }
          name: { eq: "tell_story" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    `}
    render={data => (
      <Section id="brands" accent>
        <StyledContainer>
          <div>
            <h1>Used by Biggest in Tech</h1>
            <LogoGrid>
              {LOGOS.map(({ logo, link }) => (
                <ExternalLink key={link} href={link} style={{maxWidth: '180px'}}>
                  {logo()}
                </ExternalLink>
              ))}
            </LogoGrid>
          </div>
          <Art>
            <Img fluid={data.art_story.childImageSharp.fluid} />
          </Art>
        </StyledContainer>
      </Section>
    )}
  />
);

const LogoGrid = styled.div`
  display: grid;
  grid-template-columns: .5fr .5fr;
  grid-gap: 0px;
  justify-items: center;
  margin-top: 96px;
  margin-left: 30px;

  a {
    svg {
      width: 100%;
    }
  }

  @media (max-width: ${props => props.theme.screen.sm}) {
    grid-template-columns: 1fr;
  }
`;

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: flex-end;
  position: relative;

  @media (max-width: ${props => props.theme.screen.md}) {
    justify-content: center;
  }
`;

const Art = styled.figure`
  width: 500px;
  position: absolute;
  top: -12%;
  right: 60%;

  @media (max-width: ${props => props.theme.screen.lg}) {
    top: 0;
    right: 65%;
    width: 500px;
  }

  @media (max-width: ${props => props.theme.screen.md}) {
    display: none;
  }
`;

export default UsedBy;
